import { useNavigate } from 'react-router-dom';
import { CircleAlert } from 'lucide-react';
import { ROUTES } from '@/routes/paths';
import { Button } from '@/components/ui/Button';

/** 404 del panel: cualquier URL que no exista cae aquí. */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas px-4 text-center">
      <span className="flex size-12 items-center justify-center rounded-pill bg-warning-soft text-warning-strong">
        <CircleAlert size={24} />
      </span>

      <div className="space-y-1">
        <h1 className="text-page font-bold text-ink">Página no encontrada</h1>
        <p className="text-caption text-ink-muted">
          La dirección que abriste no existe o cambió de lugar.
        </p>
      </div>

      <Button onClick={() => navigate(ROUTES.dashboard)}>Ir al panel</Button>
    </div>
  );
}
